import React, { useEffect, useState } from "react"
import Layout from "../components/layout"
import Testimonials from "../components/layoutComponents/Testimonials"
import HeroVideo from "../components/layoutComponents/HeroVideo"
import HomepageHeroVideo from "../components/layoutComponents/productVideos/home"
import Features from "../components/layoutComponents/Features"
import AutomateYourEfforts from "../components/layoutComponents/AutomateYourEfforts"
import ProFeatures from "../components/layoutComponents/ProFeatures"
import MainFeatures from "../components/layoutComponents/MainFeatures"
import IdealUseCases from "../components/layoutComponents/IdealUseCases"
import FreeTrialStrip from "../components/layoutComponents/FreeTrialStrip"
import PlansDesignedForYourNeeds from "../components/layoutComponents/PlansDesignedForYourNeeds"
import P from "../components/typography/P"
import microsoftIdentityAssociation from "../pages/.well-known/microsoft-identity-association.json"
import Loader from "../components/common/Loader"
import FlexibleDates from "../components/layoutComponents/platform/offers/FlexibleDates"
import PaymentAndBillingWrapper from "../components/layoutComponents/PaymentAndBillingWrapper"

const seo = {
  title: "Mobile Marketing Reimagined",
  description:
    "MindMe is the ultimate platform for contact management, marketing and payments.  Capture leads, convert them to customers and ignite your sales like never before.  Transform your business into a revenue powerhouse with tools that streamline your workflow and maximize growth. Dominate your market today.",
}

const Description = () => (
  <>
    <P whiteText>
      MindMe is the ultimate platform for contact management, marketing and
      payments. Capture leads, convert them to customers and ignite your sales
      like never before. Transform your business into a revenue powerhouse with
      tools that streamline your workflow and maximize growth. Dominate your
      market today.
    </P>
  </>
)

const header = (
  <HeroVideo
    title="Your All-in-One Solution to Dominate Any Market"
    description={<Description />}
    media={<HomepageHeroVideo />}
    tint="linear-gradient(271.57deg, #74C04F 5.98%, #57AC2D 87.73%)"
    whiteText
    buttonSubText="No credit card required"
    // buttonText="Free 14 Day Trial"
    imageHalf
    fullWidthButton
    buttonText="Free 14 Day Trial"
  />
)

const main = (
  <>
    <input hidden={true} value={microsoftIdentityAssociation} />
    <PaymentAndBillingWrapper />
    <FreeTrialStrip customText="All-in-One Contact Management, Marketing & Payments" />
    <Features />
    <AutomateYourEfforts />
    <FreeTrialStrip customText="Give your marketing a serious upgrade. Get started today." />
    <MainFeatures />
    <ProFeatures />
    <Testimonials />
    <FreeTrialStrip />
    <IdealUseCases />
    <PlansDesignedForYourNeeds />
  </>
)

// const IndexPage = () => <Layout header={header} main={main} seo={seo} />

// export default IndexPage

const IndexPage = () => {
  const [shouldLoad, setShouldLoad] = useState(false)

  useEffect(() => {
    // Simulate a delay or condition before loading the content
    const timer = setTimeout(() => {
      setShouldLoad(true)
    }, 1200) // Adjust the delay as needed

    return () => clearTimeout(timer)
  }, [])

  if (!shouldLoad) {
    return <Loader isLoading={true} /> // Display a loading message or spinner
  }

  return <Layout header={header} main={main} seo={seo} />
}

export default IndexPage
